/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DownSavingCreateRequest } from '../models/DownSavingCreateRequest';
import type { DownSavingReportCsvRequest } from '../models/DownSavingReportCsvRequest';
import type { DownSavingReportCsvResponse } from '../models/DownSavingReportCsvResponse';
import type { DownSavingResponse } from '../models/DownSavingResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PartnerDownSavingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns DownSavingResponse OK
     * @throws ApiError
     */
    public createDownSaving1({
        requestBody,
    }: {
        requestBody: DownSavingCreateRequest,
    }): CancelablePromise<DownSavingResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partner-apis/down-savings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingReportCsvResponse OK
     * @throws ApiError
     */
    public generateCsvReportDownSaving1({
        requestBody,
    }: {
        requestBody: DownSavingReportCsvRequest,
    }): CancelablePromise<DownSavingReportCsvResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partner-apis/down-savings/csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
